import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';
Vue.use(Vuetify);
export default new Vuetify({
    icons: {
        iconfont: 'mdi'
    },
    theme: {
        dark: false,
        themes: {
            light: {
                primary: '#0073bf',
                secondary: '#f9e11e',
                accent: '#154273',
                field: '#f3f3f3' // rws achtergrond grijs
            },
            dark: {
                primary: '#0073bf',
                secondary: '#f9e11e',
                accent: '#154273',
                field: '#f3f3f3' // rws achtergrond grijs
            }
        }
    }
});
